import { PageSkeleton, type PageSkeletonVariant } from '@/components/ui';
import { readStoredTourView } from '@/lib/tour-view-prefs';

/**
 * `PageSkeleton` for the panel: the tours home (`gallery`) takes the member's
 * stored grid size or list, so the skeleton already has the layout the page
 * will have and nothing jumps when the data lands. Every panel placeholder
 * (route fallback, shell, "account pending") goes through here.
 */
export function PanelPageSkeleton({ variant }: { variant: PageSkeletonVariant }) {
  return <PageSkeleton variant={variant} view={variant === 'gallery' ? readStoredTourView() : undefined} />;
}
